<ticker-card
  [titleText]="'crmContacts.analytics.conversion' | translate"
  total="16%"
  [percentage]="-2.3"
  icon="datausage"
  tone="warning"
></ticker-card>
